import { CheckCircle2, ListChecks } from "lucide-react"

interface PillarKeyTakeawaysProps {
  items: string[]
  /** Optional heading override. Defaults to "Key takeaways". */
  heading?: string
  className?: string
}

export function PillarKeyTakeaways({
  items,
  heading = "Key takeaways",
  className,
}: PillarKeyTakeawaysProps) {
  if (!items.length) return null
  return (
    <aside
      aria-label={heading}
      className={
        className ??
        "relative overflow-hidden rounded-2xl border border-emerald-200/80 bg-linear-to-br from-emerald-50/80 via-white to-green-50/60 px-5 py-5 shadow-xs md:px-7 md:py-6"
      }
    >
      <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/80 px-3 py-1 ring-1 ring-emerald-200/80 ring-inset">
        <ListChecks
          className="h-3.5 w-3.5 text-emerald-700"
          strokeWidth={2.4}
          aria-hidden="true"
        />
        <h2 className="m-0 text-[11px] font-bold uppercase tracking-[0.1em] text-emerald-800">
          {heading}
        </h2>
      </div>
      <ul className="m-0 flex flex-col gap-3 p-0 list-none">
        {items.map((item) => (
          <li key={item} className="flex items-start gap-3">
            <CheckCircle2
              className="mt-[3px] h-4 w-4 flex-none text-emerald-600"
              strokeWidth={2.4}
              aria-hidden="true"
            />
            <span className="text-[15px] leading-relaxed text-gray-800">
              {item}
            </span>
          </li>
        ))}
      </ul>
    </aside>
  )
}
